import { render, staticRenderFns } from "./RelatorioPedidoTotais.vue?vue&type=template&id=9b8339aa"
import script from "./RelatorioPedidoTotais.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidoTotais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports